import { useGT } from 'gt-react';
import type { WorkbookFreeformSheet } from '@erp/shared-types';
import { filledCells, freeformTableLayout } from '@erp/workbooks';

/** A freeform sheet's configuration in the Process: its filled cells and the table it gives. */
export function FreeformProcessDetails({
  sheet,
}: {
  sheet: WorkbookFreeformSheet;
}) {
  const gt = useGT();
  const context = 'workbook process freeform summary';
  const cells = filledCells(sheet);
  const formulas = cells.filter(({ input }) => input.startsWith('=')).length;
  const layout = freeformTableLayout(sheet);
  const lines = [
    gt('{cells} filled cells, {formulas} of them formulas.', {
      context,
      cells: cells.length,
      formulas,
    }),
    layout &&
      sheet.table &&
      gt('Result table {range}: {columns}.', {
        context,
        range: sheet.table.range,
        columns: layout.columns.map((column) => column.name).join(', '),
      }),
  ];
  return (
    <>
      {lines
        .filter((line) => typeof line === 'string')
        .map((line) => (
          <p key={line} className="text-sm text-muted-foreground">
            {line}
          </p>
        ))}
    </>
  );
}
